import React, { Component } from 'react'
import { Button, Form, FormGroup,
         Label, Input, Col, Row } from 'reactstrap';
import {connect} from 'react-redux';
import { getBalanceAccount} from '../actions/infoAccountActions';
import { getSettings} from '../actions/settingActions';
import { saveAccountId } from '../actions/loginActions';
import T from 'i18n-react';

class InfoRow extends Component {
  constructor(props) {
    super(props);
    console.log('InfoRow constructor');
    console.log('InfoRow props', props);
  }

  render() {
      let bal = this.props.balance;
      let formattedBal = '€ ' + parseFloat(Math.round(bal * 100) / 100).toFixed(2);
      formattedBal = formattedBal.replace('.', ',');

      return(
        <div >
            <div className="row">
              <div className="col-lg-2">
                <b><T.text tag='span' text="enter_phone"/></b>
              </div>
              <div className="col-lg-2">
                <div>{this.props.phoneNumber}</div>
              </div>

              <div className="col-lg-2">
                <b><T.text tag='span' text="license_plate_fld"/></b>
              </div>
              <div className="col-lg-2">
                <div>{this.props.licensePlate}</div>
              </div>

              <div className="col-lg-2">
                <b><T.text tag='span' text="e_wallet"/></b>
              </div>
              <div className="col-lg-2">
                <div>{
                  formattedBal
                }</div>
              </div>
          </div>
      </div>
    )
  }
}

//export default InfoRow;
const InfoRow1 = connect((state)=>{
  return {
    phoneNumber: state.authReducer.phoneNumber,
    licensePlate: state.authReducer.licensePlate,
    balance: state.authReducer.balance,
    accountId: state.authReducer.accountId
  }
},//state
{ getBalanceAccount,
  getSettings,
  saveAccountId})(InfoRow);

export default InfoRow1;



// WEBPACK FOOTER //
// ./src/components/InfoRow.js